import { ConcreteNotifications } from '../../../cimsPage/instances/concrete'
import { Notifications } from '../../common'

const { Edit, View } = Notifications({
  page: ConcreteNotifications,
  view: '865a9de4-2bfe-494d-be52-7121d1d55945',
  edit: 'ca72746a-d98f-4786-a802-9487ee7f2c24',
})

export const ViewConcreteNotification = View
export const EditConcreteNotification = Edit

export type ConcreteNotificationPermission =
  | typeof ViewConcreteNotification
  | typeof EditConcreteNotification
